import React, { useState } from 'react';
import BudgetComp from './FreelancerInfoComp/BudgetComp';
import FlSubscribersComp from './FreelancerInfoComp/FlSubscribersComp';
import BidsComp from './FreelancerInfoComp/BidsComp';
import { Descriptions, Popover, Table } from 'antd';
import moment from 'moment';
import { useMediaQuery } from 'react-responsive';

const FreelancerAccord = ({ freelancerInfo, orderData, fetchOrderDetails }) => {
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const { budget = [], bid = [] || "", subscribers = [] } = freelancerInfo || {};

    const tableData = [
        {
            key: '1',
            label: 'Moved to Freelancer Portal:',
            value: orderData?.data?.moved_to_freelancer_portal ? "Yes" : "No",
        },
        {
            key: '2',
            label: 'Freelancer Budget',
            value: budget && budget[0]?.inr_budget
                ? `${budget[0]?.inr_budget} INR`
                : "None",
        },
    ];

    const payOutTableData = [
        {
            key: '1',
            label: 'FL Deduction Orders',
            value: freelancerInfo?.fl_deduction_applied_on_payout ? "Yes" : "No",
        },
    ];

    return (
        <>
            <Table
                dataSource={tableData}
                pagination={false}
                bordered
                showHeader={false}
                rowKey="key"
                style={{ marginBottom: "10px" }}
            >
                <Table.Column
                    title="Key"
                    dataIndex="label"
                    key="label"
                    render={(text) => <strong>{text}</strong>}
                />
                <Table.Column
                    title="Value"
                    dataIndex="value"
                    key="value"
                    render={(value) => <div style={{ textAlign: 'right' }}>{value}</div>}
                />
            </Table>
            {budget.length > 1 && <BudgetComp budget={budget} />}
            <BidsComp bids={bid} fetchOrderDetails={fetchOrderDetails} />
            <FlSubscribersComp subscribers={subscribers} />
            <Table
                dataSource={payOutTableData}
                pagination={false}
                bordered
                showHeader={false}
                rowKey="key"
                style={{ marginTop: "10px" }}
            >
                <Table.Column
                    title="Key"
                    dataIndex="label"
                    key="label"
                    render={(text) => <strong>{text}</strong>}
                />
                <Table.Column
                    title="Value"
                    dataIndex="value"
                    key="value"
                    render={() => {

                        const isDeductionApplied = freelancerInfo?.fl_deduction_applied_on_payout;
                        const deductionDate = freelancerInfo?.fl_deduction_applied_at;
                        const taskDeduction = freelancerInfo?.fl_task_deduction;
                        const taskFlDeductionSum = freelancerInfo?.task_fl_deduction_sum;

                        const popoverContent = (
                            <div style={{ maxWidth: isMobile ? "80vw" : "400px" }}>
                                <Descriptions
                                    column={1}
                                    size="small"
                                    bordered
                                >
                                    <Descriptions.Item label="Applied on Payout Page">
                                        {isDeductionApplied ? "Yes" : "No"}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Deduction Date (Payout Page)">
                                        {deductionDate ? moment(deductionDate).format("DD-MM-YYYY hh:mm A") : "N/A"}
                                    </Descriptions.Item>
                                    
                                    <Descriptions.Item label="Order-Level Deduction Applied">
                                        {taskDeduction ? "Yes" : "No"}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Order-Level Total FL Deduction">
                                        {taskFlDeductionSum ?? "N/A"}
                                    </Descriptions.Item>
                                </Descriptions>
                            </div>
                        );

                        if (isDeductionApplied || taskDeduction) {
                            return (
                                <Popover
                                    trigger="click"
                                    placement={isMobile ? "top" : "left"}
                                    content={popoverContent}
                                    title="Deduction Details"
                                >
                                    <div style={{ color: "#1890ff", textAlign: "left", cursor: "pointer" }}>
                                        View
                                    </div>
                                </Popover>
                            );
                        } else {
                            return <div style={{ textAlign: "left" }}>N/A</div>;
                        }
                    }}
                />
            </Table>
        </>
    );
};

export default FreelancerAccord;
